<!-- ************************************************************************************************* -->
<waitLoading *ngIf="!isLoaded()"></waitLoading>
<!-- ************************************************************************************************* -->
<div class="wrapper wrapper-content ng-scope animated fadeInRight" *ngIf="isLoaded()">
  <div *ngIf="
    resourceFilesList && resourceFilesList.length > 0;
      else nocustomFields
    ">
    <p-panel>
      <p-header>
        <span class="label label-default float-right" style="font-size: small;font-weight: 500;">{{ 'Tasks.showing' |
          translate }} {{ resourceFilesList ? resourceFilesList.length : '0' }} logs </span>
      </p-header>
      <p-table [value]="resourceFilesList" sortField="name" sortOrder="1" [scrollable]="false" [resizableColumns]="true"
        class="footer-over-pagination" [paginator]="false">
        <ng-template pTemplate="header">
          <tr>
            <th [pSortableColumn]="'name'"> Nombre </th>
            <th [pSortableColumn]="'type'" class="TEXT"> Fecha </th>
            <th class="TEXT"> Tipo </th>
            <th class="TEXT"> Clase de recurso </th>
            <th class="action-column"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-resourceFile>
          <tr>
            <td field="name"> {{resourceFile.name}} <div>
                <span><small>{{resourceFile.description}}</small></span>
              </div>
            </td>
            <td field="type" class="TEXT"> {{resourceFile.date | date:'dd/MM/yyyy HH:mm:ss'}} </td>
            <td field="product" class="TEXT"> {{resourceFile.product ? 'Base' : 'Adaptación' }} </td>
            <td field="name" class="TEXT"> {{resourceFile.fileType.description}} </td>
            <td>
              <button type="button" class="btn btn-xs btn-default" aria-expanded="false"
                (click)="download(resourceFile)">
                <i class="fas fa-download" aria-hidden="true"></i>
              </button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-panel>
  </div>
</div>
<ng-template #nocustomFields>
  <div class="alert alert-danger m-b-xs text-ellipsis col-12 ng-star-inserted" role="alert">
    <span>
      <i aria-hidden="true" class="fas fa-1-5x fa-exclamation-circle m-r-md"></i> {{
      'ControlPanel.resourceFilesList.noResourceFilesAvailable' | translate }}</span>
  </div>
</ng-template>